import React from 'react'
import md5 from 'md5'
import './avatar.styl'

class Component extends React.Component {
  render () {
    const { email, size } = this.props
    const hash = md5(email)

    const styles = {
      backgroundImage: `url(https://www.gravatar.com/avatar/${hash}?s=200)`
    }

    let classes = 'avatar'

    if (typeof size === 'string' && size.trim() !== '') {
      classes += ' '
      classes += size
    }

    return (<div className={classes} style={styles}></div>)
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Navbar/avatar.js